module.exports = __webpack_public_path__ + "img/layout_bottom_icon.565ade26.svg";